module.exports = __webpack_public_path__ + "static/media/speakers.82edd5cd.svg";